import React from 'react';
import Box from '@mui/material/Box';

export const MIRROR_GRID_INSTRUCTION = 'Noktanın kesikli çizgiye göre ayna görüntüsünü seç.';

const axisNames = { vertical: 'Dikey', horizontal: 'Yatay', diagonal: 'Çapraz' };
const positionNames = ['sol üst', 'üst orta', 'sağ üst', 'sol orta', 'merkez', 'sağ orta', 'sol alt', 'alt orta', 'sağ alt'];

export function mirrorGridInPrompt(prompt) {
  return (prompt?.items || []).find(item => item?.kind === 'mirror_grid');
}

export function patternInstruction(question) {
  // Saved rounds and older API versions still carry the ambiguous generic wording.
  return mirrorGridInPrompt(question?.prompt) && question.instruction === 'Doğru eşleşmeyi seç.'
    ? MIRROR_GRID_INSTRUCTION : question.instruction;
}

export default function PatternMirrorGrid({ value, reference = false }) {
  const position = Math.max(1, Math.min(9, Number(value?.position || 1)));
  const axis = axisNames[value?.axis] ? value.axis : 'vertical';
  const axisName = `${axisNames[axis]} ayna çizgisi`;
  const line = axis === 'horizontal' ? { x1: 0, y1: 72, x2: 144, y2: 72 }
    : axis === 'diagonal' ? { x1: 0, y1: 0, x2: 144, y2: 144 }
    : { x1: 72, y1: 0, x2: 72, y2: 144 };
  return (
    <Box component="span" sx={{ display: 'inline-grid', justifyItems: 'center', gap: 0.5, maxWidth: '100%' }}>
      <Box component="svg" viewBox="0 0 144 144" role="img"
        aria-label={`${reference ? `${axisName.toLocaleLowerCase('tr-TR')}, ` : ''}nokta ${positionNames[position - 1]}`}
        data-testid={reference ? 'mirror-reference-grid' : 'mirror-choice-grid'}
        data-active-position={position} data-mirror-axis={reference ? axis : undefined}
        sx={{ display: 'block', width: reference ? { xs: 144, sm: 176, md: 208 } : { xs: 104, sm: 128, md: 152 }, maxWidth: '100%', height: 'auto' }}>
        <rect x="8" y="8" width="128" height="128" rx="18" fill="#fff" stroke="#a78bfa" strokeWidth="2" />
        {Array.from({ length: 9 }, (_, index) => (
          <rect key={index} x={22 + (index % 3) * 36} y={22 + Math.floor(index / 3) * 36}
            width="28" height="28" rx="7" fill="#fff" stroke="#8873af" strokeWidth="1.5" />
        ))}
        {reference ? <line data-testid="mirror-axis-line" {...line} stroke="#6d28d9" strokeWidth="3" strokeDasharray="6 4" /> : null}
        <circle data-testid="position-active-dot" cx={36 + ((position - 1) % 3) * 36}
          cy={36 + Math.floor((position - 1) / 3) * 36} r="9" fill="#312e81" />
      </Box>
      {reference ? <Box component="span" sx={{ color: '#5b21b6', fontSize: { xs: 14, md: 18 }, fontWeight: 800, textAlign: 'center' }}>
        {axisName}
      </Box> : null}
    </Box>
  );
}
